<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <section>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="6" class="padding-ten-tb float-left">
          <h5 class="title__name">Carga Masiva Capacidades Proveedor</h5>
        </b-col>
      </b-row>
      <b-row style="max-width: 100%">
        <b-col lg="12">
          <h5 class="text-underline">Instrucciones :</h5>
          <p>
            Para la correcta importacion de los datos realice los siguientes
            pasos: <br />
            1.-Generar el archivo excel que se va importar con el boton "Descargar plantilla" <br />
            2.-Guarde el archivo excel y edite los valores que se ingresaran
            <br />
            3.-Importar el archivo excel editado con el boton "Subir archivo"
            <br />
            4.-Ingresa tu correo (no es obligatorio) 
            <br />
            5.-Haz click en el botón Cargar <br />
            Nota: La actualización o carga de las capacidades se realizara en un
            intervalo de 10-15 minutos despues de haber sido cargado, se
            notificará vía correo cuando la carga haya finalizado
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12">
          <div class="vertical-align-bottom">
            <a
              class="btn-orange btn-secondary btn "
              href="/files/plantilla-servicios.xlsx"
              download
              >Descargar plantilla</a
            >
          </div>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col xs="12" sm="12" md="4" lg="4" class="padding-ten-tb float-left">
          <div class="vertical-align-bottom">
            <b-form-file
              accept=".xlsx"
              @change="onChange($event)"
              class="mt-3"
              ref="file-input"
            ></b-form-file>
          </div>
        </b-col>
      </b-row>
      <b-row style="max-width: 100%">
        <b-col lg="4" class="my-1">
          <div>
            <b-form-group label="Email" label-for="input-email">
              <b-form-input
                required
                id="input-email"
                type="email"
                v-model.trim="request.fil_email"
                size="md"
                class="placeholder-black"
                placeholder="Ingresa tu correo"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" class="text-left">
          <b-button class="btn-orange " @click="uploadFile">
            <font-awesome-icon icon="save" />
            Cargar
          </b-button>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
import { read, utils } from "xlsx";
import { mapState } from "vuex";
import axios from "axios";
import store from "@/store";
export default {
  name: "CargaMasiva",
  data() {
    return {
      file: "",
      request: {
        fil_id_proveedor: "",
        reg_usuario: "",
        fil_email: "",
        details: [
          {
            sku: "",
            capacidad: "",
            id_prov: "",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("module", ["store", "username"]),
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let perfil = store.getters["module/profile"];
    let authProvider = menu.some((m) => m.id ==30);
    if (authProvider&&perfil!=="PROVEEDOR") next();
    else next({ name: "BlockedPage" });
  },
  methods: {
    async uploadFile() {
      this.request.reg_usuario = this.username;
      this.request.fil_id_proveedor = " ";

      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.post(
          process.env.VUE_APP_API_CARGA_BASE,
          this.request,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = {
          variant: "success",
          msg:
            "Solicitud ingresada en la Cola de Generacion, favor de esperar el mensaje  de confirmación en el correo ingresado",
        };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.file = null;
        this.clearFiles();
      } catch (e) {
        let values = { variant: "danger", msg: e.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(e);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    clearFiles() {
      this.$refs["file-input"].reset();
      this.request.fil_email = "";
    },
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      console.log(this.file);
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          console.log(bstr);
          const wb = read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          console.log(ws);
          /* Convert array of arrays */
          const data = utils.sheet_to_json(ws);
          console.log(utils.sheet_to_json(ws, { header: 0 }));
          //const data = utils.sheet_to_json(ws, { header: 1 });

          var result = data.map((item) => ({
            sku: item.SKU.toString().trim(),
            turno: item.TURNO.toString().trim(),
            capacidad: item.CAPACIDAD.toString().trim(),
            dia_ini: item.DESDE.toString().trim(),
            dia_fin: item.HASTA.toString().trim(),
            id_prov: item.USU_PROV.toString().trim(),
          }));
          this.request.details = result;
        };

        reader.readAsBinaryString(this.file);
      }
    },
  },
};
</script>
